module.exports = __webpack_public_path__ + "static/media/expertise-leasing.7341ccfc.jpg";